module.exports = __webpack_public_path__ + "img/clipboard-check.4d971876.svg";